define.alias("shared/components/shared/social/instagram-modal/available-page", "settings/components/shared/social/instagram-modal/available-page");